import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { V4_API_PREFIX } from '../../api-services.config';
import { IndexScore, PaginatedV4Response } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class IndexScoresService {
  private readonly http = inject(HttpClient);
  private readonly API_PREFIX = `${V4_API_PREFIX}country/index-score/`;

  public getIndexScore({ country_code, index_version_id }: { country_code: string; index_version_id: string }): Observable<IndexScore> {
    return this.http
      .get<PaginatedV4Response<IndexScore>>(this.API_PREFIX, { params: { country_code, index_version_id } })
      .pipe(map(({ results }) => results[0]));
  }
}
